/* CP_HOME_NAV_SMOOTH_V3: per-pixel homepage lower-navigation responsiveness. */
(function () {
  'use strict';

  var WIDTH_MAX = 1280;
  var TYPE_START_WIDTH = 850;
  var WIDTH_MIN = 950;
  var GAP_MAX = 80;
  var GAP_MIN = 35;
  var FONT_MAX = 24;
  var FONT_MIN = 22;
  var frame = 0;
  var landscapeTouch = window.matchMedia(
    '(orientation: landscape) and (hover: none) and (pointer: coarse)'
  );

  function clamp(value, minimum, maximum) {
    return Math.min(maximum, Math.max(minimum, value));
  }

  function preferredGap(width) {
    if (width <= TYPE_START_WIDTH) return GAP_MIN;
    return GAP_MIN + ((width - TYPE_START_WIDTH) / (WIDTH_MAX - TYPE_START_WIDTH)) * (GAP_MAX - GAP_MIN);
  }

  function preferredFont(width) {
    if (width >= TYPE_START_WIDTH) return FONT_MAX;
    return FONT_MIN + ((width - WIDTH_MIN) / (TYPE_START_WIDTH - WIDTH_MIN)) * (FONT_MAX - FONT_MIN);
  }

  function visibleChildren(nav) {
    return Array.prototype.filter.call(nav.children, function (item) {
      return window.getComputedStyle(item).display !== 'none';
    });
  }

  function setValues(nav, gap, fontSize) {
    nav.style.setProperty('--cp-home-nav-gap', gap.toFixed(2) + 'px');
    nav.style.setProperty('--cp-home-nav-font-size', fontSize.toFixed(2) + 'px');
  }

  function totalItemWidth(items) {
    return items.reduce(function (total, item) {
      return total + item.getBoundingClientRect().width;
    }, 0);
  }

  function fitNav(nav, width) {
    if (width < WIDTH_MIN || landscapeTouch.matches) {
      nav.classList.remove('cp-nav--adaptive');
      nav.style.removeProperty('--cp-home-nav-gap');
      nav.style.removeProperty('--cp-home-nav-font-size');
      return;
    }

    nav.classList.add('cp-nav--adaptive');

    var targetFont = FONT_MAX;
    var targetGap = GAP_MAX;
    var items = visibleChildren(nav);

    if (items.length < 2) {
      setValues(nav, targetGap, targetFont);
      return;
    }

    setValues(nav, GAP_MIN, targetFont);

    var styles = window.getComputedStyle(nav);
    var usableWidth = nav.clientWidth -
      parseFloat(styles.paddingLeft || 0) -
      parseFloat(styles.paddingRight || 0);
    var fittingGap = (usableWidth - totalItemWidth(items)) / (items.length - 1);

    if (fittingGap >= GAP_MIN) {
      setValues(nav, Math.min(targetGap, fittingGap), targetFont);
      return;
    }

    var low = FONT_MIN;
    var high = targetFont;
    var best = FONT_MIN;

    for (var index = 0; index < 12; index += 1) {
      var candidate = (low + high) / 2;
      setValues(nav, GAP_MIN, candidate);
      var requiredWidth = totalItemWidth(items) + GAP_MIN * (items.length - 1);

      if (requiredWidth <= usableWidth) {
        best = candidate;
        low = candidate;
      } else {
        high = candidate;
      }
    }

    setValues(nav, GAP_MIN, best);
  }

  function update() {
    frame = 0;
    var width = window.innerWidth;
    document.querySelectorAll('.template-index .cp-home .cp-nav').forEach(function (nav) {
      fitNav(nav, width);
    });
  }

  function scheduleUpdate() {
    if (frame) return;
    frame = window.requestAnimationFrame(update);
  }

  window.addEventListener('resize', scheduleUpdate, { passive: true });
  landscapeTouch.addEventListener && landscapeTouch.addEventListener('change', scheduleUpdate);

  var observer = new MutationObserver(scheduleUpdate);
  document.querySelectorAll('.template-index .cp-home .cp-nav').forEach(function (nav) {
    observer.observe(nav, { childList: true });
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleUpdate);
  }

  scheduleUpdate();
}());
